import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { flatQuestions } from "@/lib/forms";
import { fmtDateTime } from "@/lib/fmt";
import { Empty } from "@/components/ui-helpers";

const show = (v) => (Array.isArray(v) ? v.join(", ") : v === true ? "Yes" : v === false ? "No" : v && typeof v === "object" ? (v.booked_at ? "Booked" : JSON.stringify(v)) : v ?? "");
const FILTERS = [["all", "All"], ["completed", "Completed"], ["partial", "Partial"]];

export default function ResponsesTable({ form }) {
  const [rows, setRows] = useState(null);
  const [f, setF] = useState("all");
  const nav = useNavigate();
  useEffect(() => { api.get(`/forms/${form._id}/responses`).then((r) => setRows(r.data.rows)); }, [form._id]);
  const qs = flatQuestions(form.blocks || []);
  if (!rows) return <div className="text-xs text-neutral-500">Loading…</div>;
  const partial = rows.filter((r) => r.status === "partial").length;
  const shown = rows.filter((r) => f === "all" || (f === "partial" ? r.status === "partial" : r.status !== "partial"));
  return (
    <div className="space-y-3">
      <div className="flex items-center gap-2 text-xs" data-testid="responses-filter">
        {FILTERS.map(([k, l]) => (
          <button key={k} onClick={() => setF(k)} className={`btn text-xs ${f === k ? "btn-primary" : ""}`} data-testid={`responses-filter-${k}`}>
            {l} <span className="font-mono opacity-60">{k === "all" ? rows.length : k === "partial" ? partial : rows.length - partial}</span></button>
        ))}
        <span className="text-neutral-500 ml-2">Partials are saved after each answered step and are not sent to the CRM.</span>
      </div>
      {!shown.length ? <Empty label="No responses yet" /> : (
        <div className="panel overflow-auto" data-testid="responses-table">
          <table className="w-full table-dense">
            <thead>
              <tr className="border-b">
                <th className="text-left px-3 py-2 whitespace-nowrap">Status</th>
                <th className="text-left px-3 py-2 whitespace-nowrap">Last activity</th>
                {qs.map((q) => <th key={q.id} className="text-left px-3 py-2 whitespace-nowrap max-w-[200px] truncate">{q.label || q.type}</th>)}
                <th className="text-left px-3 py-2">utm_source</th>
                <th className="text-left px-3 py-2">utm_campaign</th>
                <th className="text-left px-3 py-2">fbclid</th>
              </tr>
            </thead>
            <tbody>
              {shown.map((r) => {
                const p = r.status === "partial";
                return (
                  <tr key={r._id} className={`border-b hover:bg-[var(--panel-2)] ${p ? "" : "cursor-pointer"}`} onClick={() => !p && r.lead_id && nav(`/crm?lead=${r.lead_id}`)} data-testid={`response-row-${r._id}`}>
                    <td className="px-3 py-2 whitespace-nowrap">{p
                      ? <span className="pill" style={{ color: "#fbbf24", borderColor: "#fbbf2466" }} title={r.last_question ? `Stopped after: ${r.last_question}` : ""} data-testid={`response-partial-${r._id}`}>Partial · {r.answered}/{r.total_questions}</span>
                      : <span className="pill pill-ok">Completed</span>}</td>
                    <td className="px-3 py-2 whitespace-nowrap text-neutral-400">{fmtDateTime(r.submitted_at)}</td>
                    {qs.map((q) => (
                      <td key={q.id} className="px-3 py-2 max-w-[220px] truncate">
                        {["calendar_meet", "calendlo"].includes(q.type) ? fmtDateTime(r.answers?.[q.id]?.value) : show(r.answers?.[q.id]?.value)}
                      </td>
                    ))}
                    <td className="px-3 py-2 text-neutral-400">{r.hidden?.utm_source || "—"}</td>
                    <td className="px-3 py-2 text-neutral-400">{r.hidden?.utm_campaign || "—"}</td>
                    <td className="px-3 py-2 text-neutral-500 font-mono max-w-[120px] truncate">{r.hidden?.fbclid || "—"}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
